import Image from 'next/image';
import { UseCaseCustomerCarouselProps } from '@/components/_rebrand/UseCaseCustomerCarousel';
import { IndividualCustomerQuote } from './CustomerQuotes.types';

export const mapQuotesToCarouselCustomers = (
  quotes: IndividualCustomerQuote[]
): UseCaseCustomerCarouselProps['customers'] => {
  return quotes.map((quote) => {
    const logo = Array.isArray(quote.customerQuoteLogo) ? quote.customerQuoteLogo[0] : quote.customerQuoteLogo;

    return {
      icon: logo ? (
        <Image
          src={logo.url}
          width={logo.width}
          height={logo.height}
          alt={logo.title || ''}
        />
      ) : null,
      quote: <span>{quote.customerQuoteBody}</span>,
      authorName: quote.customerQuoteAuthorName,
      authorTitle: quote.customerQuoteAuthorTitle,
    };
  });
};
